export const APP_PORT = process.env.PORT ?? process.env.VITE_PORT;
export const AZURE_BLOB_CONTAINER = process.env.VITE_AZURE_BLOB_CONTAINER as string;
